import React from 'react'

import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components'

import AlertBadge from 'assets/icons/alert-badge.png'
import Environment from 'utils/environment'

type Props = {
  isExceptionModalOpen: boolean
  handleCloseExceptionModal: () => void
  env: Environment
}

export const NoSuspendedTokenExceptionModal = (props: Props) => {
  return (
    <ConfirmationModal
      isOpen={props.isExceptionModalOpen}
      actions={[
        {
          handler: props.handleCloseExceptionModal,
          label: 'Cancel',
          type: ModalActionTypes.secondary,
        },
        {
          href: 'https://support.acorns.com/hc/en-us/articles/How-do-I-contact-Acorns',
          label: 'Contact Support',
          type: ModalActionTypes.primary,
        },
      ]}
      title="Acorns Account Suspended"
      message="For security purposes, we've temporarily suspended your Acorns account. Please check your email for instructions on how to regain access. Or, feel free to contact our Support team."
      image={AlertBadge}
    />
  )
}
